<template>
  <div class="position-relative flex items-center justify-center">
    <div
      id="logo-cont"
      :class="{
        'w-full h-full position-relative': true,
        'fade-blur': page === 2,
      }"
    >
      <img id="logo" src="/img/LogoIcon.png" />
    </div>
    <p v-if="page === 2" id="educate" class="text">
      We Educate
    </p>
    <p v-if="page === 2" id="design" class="text"><span class="tran">We</span> Design</p>
    <p v-if="page === 2" id="collab" class="text"><span class="tran">We</span> Collaborate</p>
    <p v-if="page === 2" id="innov" class="text"><span class="tran">We</span> Innovate</p>
    <div v-if="page === 2" id="main">
      <h1 class="font-medium text-4xl text-center">
        We are DesignMorphine
      </h1>
      <h2 class="font-light text-right text-3xl">
        your design addiction
      </h2>
    </div>
  </div>
</template>

<script>
export default {
  name: 'home',
  data() {
    return {
      page: 1,
      hammer: null,
    };
  },
  mounted() {
    this.$bus.$off('scrollDown');
    this.hammer = new Hammer(window, {
      recognizers: [[Hammer.Pan, { direction: Hammer.DIRECTION_ALL }]],
    });

    this.hammer.on('panup', this.scroll);
    window.addEventListener('wheel', this.scroll);
    this.$bus.$on('scrollDown', () => {
      if (this.page === 1) {
        this.scroll(null, true);
        return;
      }

      if (this.page === 2) {
        this.complete(null, true);
      }
    });
  },
  beforeDestroy() {
    if (this.page === 1) {
      window.removeEventListener('wheel', this.scroll);
      this.hammer.off('panup', this.scroll);
    } else {
      window.removeEventListener('wheel', this.complete);
      this.hammer.off('panup', this.complete);
    }

    // this.$bus.$off("scrollDown");
  },
  methods: {
    scroll(event, button = false) {
      if (button || event.deltaY > 50 || (event.type === 'panup' && event.deltaY < -50)) {
        this.$bus.$emit('hide-skip');
        this.hammer.off('panup', this.scroll);
        window.removeEventListener('wheel', this.scroll);
        this.page++;
        setTimeout(() => {
          if(this.$route.name === 'home') {
            window.addEventListener('wheel', this.complete);
            this.hammer.on('panup', this.complete);
          }
        }, 2000);
      }
    },
    complete(event, button = false) {
      if (button || event.deltaY > 50 || (event.type === 'panup' && event.deltaY < -50)) {
        this.hammer.off('panup', this.complete);
        window.removeEventListener('wheel', this.complete);
        this.$router.push({ name: 'education' });
      }
    },
  },
};
</script>

<style scoped lang="scss">
#logo {
  max-width: 100%;
  max-height: 100%;
  opacity: 0.1;
  -webkit-animation: spinner 10s linear infinite;
  animation: spinner 10s linear infinite;
}

#logo-cont {
  display: flex;
  align-items: center;
  justify-content: center;
  max-height: 70%;

  @media screen and (max-width: 500px) {
    @apply px-2;
  }

  @media screen and (max-width: 1024px) {
    @apply px-16;
  }

  @media screen and (min-width: 1024px) {
    @apply px-24;
  }

  @media screen and (min-width: 1800px) {
    @apply px-48;
  }
}

.text {
  position: absolute;
  font-size: 2.25rem;
  left: 2rem;
  @media screen and (max-width: 650px) {
    left: 1rem !important;
  }
}

.tran {
  color: transparent !important;
}

#educate {
  animation: slide 3s ease-in-out;
  animation-fill-mode: forwards;
}

#design {
  animation: slide1 3s ease-in-out;
  animation-fill-mode: forwards;
}

#collab {
  animation: slide2 3s ease-in-out;
  animation-fill-mode: forwards;
}

#innov {
  animation: slide3 3s ease-in-out;
  animation-fill-mode: forwards;
}

#main {
  width: 65%;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: slide4 3s ease-in-out;
  animation-fill-mode: forwards;

  @media screen and (max-width: 500px) {
    width: 90% !important;
  }
}

.fade-blur {
  animation: fadeBlur 3s ease-in-out;
  animation-fill-mode: forwards;
}

@keyframes spinner {
  0% {
    opacity: 0.1;
  }
  50% {
    opacity: 0.8;
  }
  100% {
    opacity: 0.1;
  }
}

@keyframes slide {
  0% {
    top: 40rem;
    opacity: 0;
  }
  100% {
    top: 1.5rem;
    opacity: 1;
  }
}

@keyframes slide1 {
  0% {
    top: 67.5rem;
    opacity: 0;
  }
  100% {
    top: 4.25rem;
    opacity: 1;
  }
}

@keyframes slide2 {
  0% {
    top: 95rem;
    opacity: 0;
  }
  100% {
    top: 7rem;
    opacity: 1;
  }
}

@keyframes slide3 {
  0% {
    top: 132.5rem;
    opacity: 0;
  }
  100% {
    top: 9.75rem;
    opacity: 1;
  }
}

@keyframes slide4 {
  0% {
    bottom: -10%;
    opacity: 0;
  }
  100% {
    bottom: 5%;
    opacity: 1;
  }
}

@keyframes fadeBlur {
  0% {
    opacity: 1;
    filter: blur(0);
  }
  100% {
    filter: blur(12px);
    opacity: 0.3;
  }
}
</style>
